import { render, staticRenderFns } from "./view-layout.vue?vue&type=template&id=e42975ba&scoped=true"
import script from "./view-layout.vue?vue&type=script&lang=js"
export * from "./view-layout.vue?vue&type=script&lang=js"
import style0 from "./view-layout.vue?vue&type=style&index=0&id=e42975ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e42975ba",
  null
  
)

export default component.exports